<template>
  <div class="admin-tag-list">
    <!-- 左边：标签导航栏 -->
    <div class="tag-content" :style="{ left: $store.state.isCollapse ? '60px' : '210px' }">
      <el-tabs v-model="activeTab" type="card" class="demo-tabs" @tab-remove="removeTab" @tab-change="tabChange" style="min-width: 10px">
        <el-tab-pane v-for="item in tabList" :key="item.path" :label="item.title" :name="item.path" :closable="item.path != '/admin'"> </el-tab-pane>
      </el-tabs>

      <!-- 右侧下拉菜单 -->
      <span class="tag-right-down">
        <el-dropdown @command="handleCloseTab">
          <span class="el-dropdown-link">
            <el-icon>
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="closeOthers">关闭其他</el-dropdown-item>
              <el-dropdown-item command="closeAll">关闭全部</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </span>
    </div>
    <div class="tag-content-shadow"></div>
  </div>
</template>

<script setup lang="ts">
import { useTabList } from '@/hooks/use-tag-list'
import { ArrowDown } from '@element-plus/icons-vue'
const { activeTab, tabList, tabChange, removeTab, handleCloseTab } = useTabList()
</script>
<style scoped lang="less">
.tag-content {
  position: fixed;
  top: 64px;
  height: 44px;
  padding-left: 16px;
  padding-right: 16px;
  right: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  background-color: white;
  transition: all 300ms;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.tag-content-shadow {
  height: 44px;
}

.tag-right-down {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
}

:deep(.el-tabs__item) {
  background-color: #fff !important;
  color: #333 !important;
  font-size: 12px !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
  margin: 0 8px 0 0 !important;
  padding: 0 16px !important;
}

:deep(.el-tabs__item.is-active) {
  background-color: var(--el-color-primary) !important;
  color: #fff !important;
  border-color: var(--el-color-primary) !important;
}

:deep(.el-tabs__item.is-active::before) {
  content: '';
  background-color: #fff;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: relative;
  margin-right: 6px;
}

:deep(.el-tabs) {
  height: 32px;
}

:deep(.el-tabs__header) {
  margin-bottom: 0;
}

:deep(.el-tabs--card > .el-tabs__header .el-tabs__nav) {
  border: 0;
}

:deep(.el-tabs--card > .el-tabs__header .el-tabs__item) {
  height: 32px;
  line-height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin: 0 8px 0 0;
  padding: 0 16px;
  font-size: 12px;
}

:deep(.el-tabs--card > .el-tabs__header) {
  border: 0;
}

:deep(.el-tabs__nav-prev),
:deep(.el-tabs__nav-next) {
  line-height: 35px;
}

:deep(.is-disabled) {
  cursor: not-allowed;
  color: #d1d5db;
}
</style>
